const pages = [
  {
    id: 0,
    name: 'Carta de venta'
  },

  {
    id: 1,
    name: 'Carta de agradecimiento'
  }
]

export default pages
